import { Component } from 'react';
import type { ErrorInfo, ReactNode } from 'react';

interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  override state: ErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  override componentDidCatch(error: Error, info: ErrorInfo): void {
    // Client-side crash: log safely, never surface stack traces to the user.
    console.error('unhandled_render_error', error.message, info.componentStack);
  }

  override render(): ReactNode {
    if (this.state.hasError) {
      return (
        <div
          role="alert"
          className="flex h-full min-h-screen flex-col items-center justify-center gap-2 bg-bg-app px-6 text-center"
        >
          <h1 className="text-2xl font-semibold text-text-primary">Algo deu errado</h1>
          <p className="text-sm text-text-secondary">
            Ocorreu um erro inesperado. Recarregue a página.
          </p>
        </div>
      );
    }

    return this.props.children;
  }
}
